import React from 'react'
import styled from 'styled-components'
import { Row, Col } from 'reactstrap'
import get from 'lodash/get'
import { LeaveChart, LeaveChartEntitlement } from '../../components/my-leave/chart'

export const Dashboard = (props) => {
  return (
    <ChartRow>
      { get(props, 'prettyLeaveGeneration', []).map(leaveGeneration => {
        return (
          <ChartCol
            md="4"
            lg="3"
            key={ get(leaveGeneration, 'name') }
          >
            <LeaveChartEntitlement
              header={ get(leaveGeneration, 'name') }
              remain={ get(leaveGeneration, 'meta.remaining') }
              pending={ get(leaveGeneration, 'meta.pending') }
              used={ get(leaveGeneration, 'meta.approved') }
              total={ get(leaveGeneration, 'meta.total') }
            />
          </ChartCol>
        )
      })}
      { get(props, 'prettyLeaveTypeWithLeaveRequest', []).map(leaveGeneration => {
        return (
          <ChartCol
            md="4"
            lg="3"
            key={ get(leaveGeneration, 'name') }
          >
            <LeaveChart
              header={ get(leaveGeneration, 'name') }
              remain={ get(leaveGeneration, 'remaining') }
              pending={ get(leaveGeneration, 'pending') }
              used={ get(leaveGeneration, 'approved') }
              total={ get(leaveGeneration, 'total') }
            />
          </ChartCol>
        )
      })}
    </ChartRow>
  )
}

const ChartRow = styled(Row)`
  padding: 10px;
  padding-right: 25px;
  padding-left: 25px;
  overflow-y: auto ;
  max-height: calc(100vh - 150px);
  @media (max-width: 575.98px) {
    max-height: calc(100vh - 150px);
  }
  @media (max-width: 767.98px) {
    max-height: calc(100vh - 150px);
  }
  @media (max-width: 991.98px) {
    max-height: calc(100vh - 150px);
  }
`
const ChartCol = styled(Col)`
  padding: 5px ;
  margin-bottom: 5px;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/my-leave/dashboard.js